import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.51 1.26h-7A2.75 2.75 0 0 0 1.75 4v8a2.76 2.76 0 0 0 2.75 2.71h7A2.75 2.75 0 0 0 14.26 12V4a2.75 2.75 0 0 0-2.75-2.74ZM12.76 12a1.25 1.25 0 0 1-1.25 1.25h-7A1.25 1.25 0 0 1 3.25 12V8.73h9.51Zm0-4.73H3.25V4A1.25 1.25 0 0 1 4.5 2.76h7A1.25 1.25 0 0 1 12.76 4Zm-3.41 4.47H6.66a.75.75 0 1 1 0-1.5h2.69a.75.75 0 0 1 0 1.5Zm0-6H6.66a.75.75 0 0 1 0-1.5h2.69a.75.75 0 0 1 0 1.5Z';
const draw24px =
  'M18.19,2.36H5.81A2.75,2.75,0,0,0,3.06,5.11V18.89a2.75,2.75,0,0,0,2.75,2.75H18.19a2.75,2.75,0,0,0,2.75-2.75V5.11A2.75,2.75,0,0,0,18.19,2.36Zm1.25,16.53a1.25,1.25,0,0,1-1.25,1.25H5.81a1.25,1.25,0,0,1-1.25-1.25V12.75H19.44Zm0-7.64H4.56V5.11A1.25,1.25,0,0,1,5.81,3.86H18.19a1.25,1.25,0,0,1,1.25,1.25ZM14,15.69H10a.75.75,0,0,1,0-1.5h4a.75.75,0,0,1,0,1.5Zm0-8.94H10a.75.75,0,0,1,0-1.5h4a.75.75,0,0,1,0,1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CabinetIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'cabinet'),
) as IconWithRender;

CabinetIcon.displayName = 'CabinetIcon';
CabinetIcon.propTypes = Icon.propTypes;
CabinetIcon.renderIcon = (props) => <CabinetIcon {...props} />;
export default CabinetIcon;
